/*
 * Voyado header Size pills.
 * -------------------------
 * Fills the collection header's [data-voyado-header-size-pills] from the SIZE facet
 * of the landing response (cloning <template data-tmpl-header-size-pill>) and toggles
 * a clicked size in/out of the SIZE filter (multi-select). Driven by voyado-plp-controller.js
 * — collection only; the search header has no placeholder, so build() is a no-op there.
 * Lives outside the controller to keep it under the 500-LOC ceiling (TECH-DEBT #78).
 *
 * window.VoyadoHeaderSize.build(ctl)        — render pills from ctl.facetsData
 * window.VoyadoHeaderSize.apply(ctl, value) — commit the size + re-load the grid
 */
;(function () {
  'use strict';

  function build(ctl) {
    const host = ctl.headerSizePills;
    if (!host) return;
    const facet = (ctl.facetsData || []).find(function (f) { return f.type === 'SIZE'; });
    if (!facet) { host.replaceChildren(); ctl._headerSizeId = null; return; }
    ctl._headerSizeId = facet.id;
    // Flatten ALL sizeTypes/formats (not just [0]) — see voyado-facet-renderer.
    const values = (facet.sizeTypes || []).reduce(function (acc, st) {
      (st.formats || []).forEach(function (fmt) { if (fmt.values) acc.push.apply(acc, fmt.values); });
      return acc;
    }, []);
    const active = ctl.committed[facet.id] || [];
    const frag = document.createDocumentFragment();
    values.forEach(function (v) {
      const li = window.voyadoTmpl('header-size-pill');
      if (!li) return;
      const btn = li.querySelector('[data-voyado-header-size]');
      const label = li.querySelector('[data-slot="label"]');
      if (label) label.textContent = 'Size ' + v.label; // TODO(i18n)
      if (btn) {
        btn.setAttribute('data-voyado-header-size', v.id);
        if (active.indexOf(v.id) >= 0) btn.setAttribute('data-active', 'true');
      }
      frag.appendChild(li);
    });
    host.replaceChildren(frag);
  }

  // Multi-select: clicking a size toggles it in/out of the committed SIZE set.
  function apply(ctl, valueId) {
    const fid = ctl._headerSizeId;
    if (!fid) return;
    const cur = (ctl.committed[fid] || []).slice();
    const i = cur.indexOf(valueId);
    if (i >= 0) cur.splice(i, 1);
    else cur.push(valueId);
    if (cur.length) ctl.committed[fid] = cur;
    else delete ctl.committed[fid];
    ctl.pending = JSON.parse(JSON.stringify(ctl.committed));
    ctl.syncUrl();
    ctl.load(true);
  }

  window.VoyadoHeaderSize = { build: build, apply: apply };
})();
